/**
 *  Toggle light / dark theme function
 *  <button id="theme-toggle" aria-label="Toggle theme">🌓</button>
 * 
 */

(function(){
  const btn = document.getElementById('theme-toggle');
  if(!btn) return;
  btn.addEventListener('click', function(){
    const isDark = document.body.classList.toggle('theme-dark');
    localStorage.setItem('theme-preference', isDark ? 'dark' : 'light');
  });
})();